/* Yazı detayı — içerikteki h2/h3 başlıklarından otomatik "İçindekiler".
   [data-toc-target] varsa (rehber kenar çubuğu) liste oraya yazılır;
   yoksa içerik başına kutu olarak eklenir. 2'den az başlıkta görünmez. */
(function () {
	var content = document.querySelector('.post-content');
	if (!content) return;

	var target = document.querySelector('[data-toc-target]');
	var headings = content.querySelectorAll(target ? 'h2' : 'h2, h3');
	var minCount = target ? 2 : 3;
	if (headings.length < minCount) {
		if (target && target.parentElement) target.parentElement.hidden = true;
		return;
	}

	var list = document.createElement('ol');
	headings.forEach(function (h, i) {
		if (!h.id) h.id = 'baslik-' + (i + 1);
		var li = document.createElement('li');
		var a = document.createElement('a');
		a.href = '#' + h.id;
		a.textContent = h.textContent;
		li.appendChild(a);
		list.appendChild(li);
	});

	if (target) {
		target.appendChild(list);

		/* Scroll-spy: görünürdeki bölümün TOC satırını turuncu şeritle işaretle */
		var items = list.querySelectorAll('li');
		var ticking = false;
		function highlight() {
			ticking = false;
			var activeIndex = 0;
			for (var i = 0; i < headings.length; i++) {
				if (headings[i].getBoundingClientRect().top <= 160) activeIndex = i;
			}
			items.forEach(function (li, i) {
				li.classList.toggle('is-active', i === activeIndex);
			});
		}
		window.addEventListener('scroll', function () {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(highlight);
		}, { passive: true });
		highlight();
		return;
	}

	var box = document.createElement('nav');
	box.className = 'article-toc';
	box.setAttribute('aria-label', 'İçindekiler');
	var title = document.createElement('strong');
	title.className = 'article-toc__title';
	title.textContent = 'İçindekiler';
	box.appendChild(title);
	box.appendChild(list);
	content.insertBefore(box, content.firstChild);
})();
